import { AxiosResponse } from "axios";
import httpClient, { apiRoutePrefix } from "../httpClient/httpClient";

export const TaskService = {
  async exportTaskToExcel(parentTaskId: string) {
    const res = await httpClient.get(
      `${apiRoutePrefix}/exportTaskToExcel/${parentTaskId}`,
      { responseType: "blob" }
    );
    return res;
  },
  async exportOptimizelyTaskToExcel(parentTaskId: string) {
    const res = await httpClient.get(
      `${apiRoutePrefix}/optimizely/exportTaskToExcel/${parentTaskId}`,
      { responseType: "blob" }
    );
    return res;
  },
  async createBulkTask(payload: {
    user_subscriptions_id: number;
    assigned_bot_id: number;
    title?: string;
    product_title?: string;
    product_details?: string;
    brand?: string;
    materials?: string;
    bulk_children: Array<{
      product_title: string;
      product_details: string;
      brand?: string;
      materials?: string;
    }>;
  }): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/createBulkTask`,
      payload
    );
    return res;
  },
  async getTaskHistory(
    selectedHelenId?: any,
    page?: any,
    pageSize?: any,
    status?: any,
    startDate?: any,
    endDate?: any,
    sortField?: any,
    sortDirection?: any,
    searchTerm?: any
  ): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/getTaskHistory`,
      {
        helenId: selectedHelenId,
        startDate: startDate,
        endDate: endDate,
        page: page,
        pageSize: pageSize,
        status: status,
        sortBy: sortField,
        sortDirection: sortDirection,
        searchTerm: searchTerm,
      }
    );
    return res;
  },
  async createSingleTask(
    subscriptionId: any,
    selectedHelenId: any,
    productTitle: any,
    productDetails: any,

    brand: any,
    materials: any,
    type: any
  ): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/createSingleTask`,
      {
        user_subscriptions_id: subscriptionId,
        task_type: type,
        assigned_bot_id: selectedHelenId,
        product_title: productTitle,
        product_details: productDetails,
        brand: brand,
        materials: materials,
      }
    );
    return res;
  },
  getTasks: async (helen_id: string): Promise<AxiosResponse> => {
    try {
      const params = new URLSearchParams();
      params.append("helen_id", helen_id);

      const res = await httpClient.get<AxiosResponse>(
        `${apiRoutePrefix}/getTasks?${params.toString()}`
      );

      return res;
    } catch (err) {
      throw err;
    }
  },
  async updateTaskStatus(taskId: any, newStatus: any): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/updateTaskStatus`,
      {
        task_id: taskId,
        new_status: newStatus,
      }
    );
    return res;
  },
  async getOptimizelyTasks(params: {
    assigned_bot_id: number;
    page?: number;
    pageSize?: number;
    status?: string;
    startDate?: string;
    endDate?: string;
    sortBy?: string;
    sortDirection?: string;
    searchTerm?: string;
  }): Promise<AxiosResponse> {
    const query = new URLSearchParams();
    query.append("assigned_bot_id", String(params.assigned_bot_id));
    if (params.page != null) query.append("page", String(params.page));
    if (params.pageSize != null) query.append("pageSize", String(params.pageSize));
    if (params.status) query.append("status", params.status);
    if (params.startDate) query.append("startDate", params.startDate);
    if (params.endDate) query.append("endDate", params.endDate);
    if (params.sortBy) query.append("sortBy", params.sortBy);
    if (params.sortDirection) query.append("sortDirection", params.sortDirection);
    if (params.searchTerm) query.append("searchTerm", params.searchTerm);
    const res = await httpClient.get<AxiosResponse>(
      `${apiRoutePrefix}/optimizely/tasks?${query.toString()}`
    );
    return res;
  },
  async createOptimizelyBulkTask(payload: {
    user_subscriptions_id: number;
    assigned_bot_id: number;
    title?: string;
    bulk_children: Array<{
      product_title: string;
      product_details: string;
      brand?: string;
      materials?: string;
      product_number?: string;
    }>;
  }): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/optimizely/tasks`,
      payload
    );
    return res;
  },

  async getOptimizelyFieldMappings(): Promise<AxiosResponse<{ fieldMapping: { id: number; user_id: number; mappings: Record<string, string>; version: number } }>> {
    return httpClient.get(`${apiRoutePrefix}/optimizely/fieldMappings`);
  },

  async updateOptimizelyFieldMappings(mappings: Record<string, string>): Promise<AxiosResponse<{ fieldMapping: { id: number; user_id: number; mappings: Record<string, string>; version: number } }>> {
    return httpClient.put(`${apiRoutePrefix}/optimizely/fieldMappings`, { mappings });
  },

  async deleteOptimizelyFieldMappings(): Promise<AxiosResponse<any>> {
    return httpClient.delete(`${apiRoutePrefix}/optimizely/fieldMappings`);
  },
};
